import { useMemo } from 'react';
import { object, string } from 'yup';

export const getTemplateValidationSchema = ({ t, type, name }) => useMemo(
	() =>
		object().shape({
			name: string().required(t('ALLOPATHY.VALIDATION.IS_REQUIRED', { value: name })),
		}),
	[t, type, name],
);